module.exports = __webpack_public_path__ + "static/media/michael metallo.36c7cf32.png";